import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const BaseFacilitySchema = z.object({
  facility_id: uuidSchema,
  hospital_id: uuidSchema,
  enterprise_id: uuidSchema,
  tenant_id: uuidSchema,
  facility_code: z.string().max(50),
  facility_name: z.string().max(300),
  facility_type: z.string().max(100),
  floor_level: z.string().max(20).nullable().optional(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type BaseFacility = z.infer<typeof BaseFacilitySchema>;

/** Schema used to parse raw Prisma rows (Date -> ISO string) before returning */
export const FacilityResponseSchema = BaseFacilitySchema.extend({
  created_at: z.coerce.date().transform((d) => d.toISOString()),
  updated_at: z.coerce.date().transform((d) => d.toISOString()),
});

export type FacilityResponse = z.infer<typeof FacilityResponseSchema>;

export const CreateFacilityRequestSchema = z.object({
  hospitalId: uuidSchema,
  tenantId: uuidSchema,
  facilityCode: z.string().min(1).max(50),
  facilityName: z.string().min(1).max(300),
  facilityType: z.string().min(1).max(100),
  floorLevel: z.string().max(20).nullable().optional(),
});

export type CreateFacilityRequest = z.infer<typeof CreateFacilityRequestSchema>;

export const UpdateFacilityRequestSchema = z.object({
  facilityCode: z.string().min(1).max(50).optional(),
  facilityName: z.string().min(1).max(300).optional(),
  facilityType: z.string().min(1).max(100).optional(),
  floorLevel: z.string().max(20).nullable().optional(),
});

export type UpdateFacilityRequest = z.infer<typeof UpdateFacilityRequestSchema>;
